import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { IAppState } from '../../../models/reduxState';
import { updateUITabViewInfo } from '../../app/appActions';
import {
  getCorrelationId,
  currentUITabViewSelector,
  isSupportTabEnabled,
  isNonAgaveSelector,
  isTeamsSelector,
  isCMCRequestCreationDeeplinkSelector,
} from '../../app/selectors/contactUsSelector';
import { Navigation } from '../presentationalComponents/Navigation';
import { resetSearchSession } from '../reduxUpdater/actions/selfHelpAlchemyActions';
import { isRequestHistoryTabEnabledSelector, isSupportNavEnabledSelector, isUseIconsForSupportNavEnabledSelector } from '../reduxUpdater/selectors/requestSelector';
import { getMainNavigationStyles } from '../styles/appStyles';

const mapStateToProps = (state: IAppState, _ownProps: any) => {
  return {
    showSupportNav: isSupportNavEnabledSelector(state),
    useIconsForSupportNav: isUseIconsForSupportNavEnabledSelector(state),
    isSignedIn: state.ContactState.ModalitySectionState.isSignedIn,
    currentUITabView: currentUITabViewSelector(state),
    appName: state.GlobalState.sourceApp || state.GlobalState.appVer,
    showHistoryTab: isRequestHistoryTabEnabledSelector(state),
    appVer: state.GlobalState.appVer,
    sourceApp: state.GlobalState.sourceApp,
    isNonAgave: isNonAgaveSelector(state),
    correlationId: getCorrelationId(state),
    market: state.GlobalState.market,
    environment: state.GlobalState.environment,
    isSupportTabEnabled: isSupportTabEnabled(state),
    createdRequest: state.ContactState.ModalitySectionState.createdRequest,
    isSearchSessionResetEnabled: state.ContactState.SharedState.isSearchSessionResetEnabled,
    isTeams: isTeamsSelector(state),
    isCMCRequestCreationDeeplink: isCMCRequestCreationDeeplinkSelector(state),
    isRequestCreationTabHidden: state.NavState.requestCreationTabHidden,
  };
};

const mapDispatchToProps = {
  updateUITabViewInfo,
  resetSearchSession,
};

export const NavigationContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(Navigation, getMainNavigationStyles));
